import { createFileRoute } from '@tanstack/react-router'
import { UserProfileSettings } from '~/features/settings/components/AccountProfileSettings'
import { useAppStore } from '~/stores'

export const Route = createFileRoute('/workspaces/$workspaceId/profile/account')({
  component: () => {
    const params = Route.useParams()
    const user = useAppStore((s) => s.currentUser)

    if (!user) {
      return <div>Loading...</div>
    }
    return <UserProfileSettings user={user} workspaceId={params.workspaceId} />
  },
})
